/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import L from 'leaflet';

const getTouristAttractionMarkerIcon = (type = 'pin', className = '') => {
  if (type === 'unknown') {
    type = 'pin';
  }

  let icon;

  try {
    icon = require(`@static/images/icons/tourist_attractions/${type}.svg`);
  } catch (error) {
    icon = require('@static/images/icons/tourist_attractions/ticket.svg');
  }

  return new L.Icon({
    iconUrl: icon,
    iconRetinaUrl: icon,
    iconAnchor: null,
    popupAnchor: [0, -18],
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    className,
    iconSize: new L.Point(36, 36),
  });
};

export default getTouristAttractionMarkerIcon;
